import type { ImageGallerySection } from "@/types/content";

interface Props {
  section: ImageGallerySection;
}

export default function ImageGallerySectionBlock({ section }: Props) {
  const layout = section.layout || "grid";

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div
        className={`max-w-6xl mx-auto ${
          layout === "grid"
            ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
            : layout === "masonry"
              ? "columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4"
              : "flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory"
        }`}
      >
        {section.images.map((img) => (
          <div
            key={img._key}
            className={`${layout === "carousel" ? "snap-start shrink-0 w-[300px] sm:w-[400px]" : "break-inside-avoid"}`}
          >
            <div className="relative overflow-hidden rounded-lg">
              <img
                loading="lazy"
                src={img.url}
                alt={img.alt}
                className="w-full h-auto object-cover"
              />
            </div>
            {img.caption && (
              <p className="text-sm text-slate-500 mt-2">{img.caption}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}